/**
 * Enum for the different types of group by date available for widgets
 * @enum {string}
 * @readonly
 */
export const GroupDateTypes = Object.freeze({
  /** Years */
  YEARS: 'year',

  /** Months */
  MONTHS: 'month',

  /** Weeks */
  WEEKS: 'week',

  /** Days */
  DAYS: 'day',

  /** Hours */
  HOURS: 'hour',

  /** Minutes */
  MINUTES: 'minute',

  /** Seconds */
  SECONDS: 'second'
});
